// Copyright (c) 2017 Deere & Company

import auditList from './audit-list';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import dealerHierarchyFacet from './dealer-hierarchy-facet';
import facetFilterText from './facet-filter-text';
import filteredTerritories from './filtered-territories';
import initialLoad from './initial-load.js';
import leadAccount from './lead-accounts';
import reportsAccordion from './reports-accordion';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    auditList,
    busyCounter,
    confirmationModal,
    dealerHierarchyFacet,
    facetFilterText,
    filteredTerritories,
    initialLoad,
    leadAccount,
    reportsAccordion,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/index.js